import { Card, CardContent } from '@/components/ui/card';

export const StatCard = ({ icon: Icon, label, value, sub, color }) => (
  <Card className="bg-card border-border">
    <CardContent className="p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-9 h-9 rounded-sm flex items-center justify-center ${color || 'bg-primary/10'}`}>
          <Icon className={`w-4 h-4 ${color ? 'text-white' : 'text-primary'}`} />
        </div>
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
      <div className="text-2xl font-black tracking-tight">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </CardContent>
  </Card>
);
